import { IGridTile } from "@faire/web-api--source/indigofair/data/IGridTile";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { optimizeImageUrlFillSquare } from "@faire/web/common/images/optimizeImages";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

interface IProps {
  valueProps: IGridTile[];
}

export const ValueProps: React.FC<IProps> = ({ valueProps }) => {
  const isSSR = useIsSSR();
  const { isMobile } = useViewport();
  const imageSize = isMobile ? 16 : 24;
  return (
    <>
      {valueProps.map((valueProp, index) =>
        valueProp.avatar_image !== undefined ? (
          <ValuePropsRow key={index}>
            <IconImage
              src={optimizeImageUrlFillSquare(
                valueProp.avatar_image,
                isSSR,
                48 // standardize size for better resolution
              )}
              width={imageSize}
              height={imageSize}
            />
            <Typography
              variant={
                isMobile ? "paragraphSansRegular" : "subheadingSansRegular"
              }
            >
              {valueProp.description_text}
            </Typography>
          </ValuePropsRow>
        ) : null
      )}
    </>
  );
};

const IconImage = styled.img`
  align-self: start;
`;

const ValuePropsRow = styled(Row).attrs({
  align: "center",
  gap: { mobileAndAbove: "1x", tabletAndAbove: "2x" },
})`
  ${responsiveMediaQueries.mobile} {
    padding-top: ${getSpacing("1x")};
  }

  padding-top: ${getSpacing("2x")};
`;
